// extracted by mini-css-extract-plugin
module.exports = {"DateTime":"DateTime_DateTime__x5266","Display":"DateTime_Display__3FspN","Value":"DateTime_Value__2Af8u","Icon":"DateTime_Icon__32EOj"};